import { IProductTilePriceAndBrandNameXP } from "@faire/web-api--source/indigofair/data/IProductTilePriceAndBrandNameXP";
import { PRICE_FIRST_AND_NEW_BRAND_LINK_ON_SEARCH_TILE_241029 } from "@faire/web-api--source/indigofair/settings/PRICE_FIRST_AND_NEW_BRAND_LINK_ON_SEARCH_TILE_241029";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingPriceFirstAndNewBrandLink =
  (): IProductTilePriceAndBrandNameXP => {
    return useSetting(
      PRICE_FIRST_AND_NEW_BRAND_LINK_ON_SEARCH_TILE_241029,
      IProductTilePriceAndBrandNameXP.Bucket.CONTROL
    );
  };
